var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122112",
    d: "M4.275 2.7A2.475 2.475 0 0 0 1.8 5.175v7.65A2.475 2.475 0 0 0 4.275 15.3h9.45a2.475 2.475 0 0 0 2.475-2.475v-4.95A2.475 2.475 0 0 0 13.725 5.4h-8.55c-.374 0-.675.301-.675.675s.3.675.675.675h8.55c.621 0 1.125.504 1.125 1.125v4.95c0 .622-.504 1.125-1.125 1.125h-9.45a1.125 1.125 0 0 1-1.125-1.125v-7.65c0-.621.503-1.125 1.125-1.125h10.35c.374 0 .675-.3.675-.675a.673.673 0 0 0-.675-.675zm8.325 8.55a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8"
  })));
};
export default SvgWallet;